"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useFullscreen = _interopRequireDefault(require("../../../../hooks/useFullscreen"));
var _useSlider = _interopRequireDefault(require("../../hooks/useSlider"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Fullscreen = function Fullscreen(_a) {
  var className = _a.className;
  var _b = (0, _useSlider.default)(),
    variant = _b.variant,
    wrapperElement = _b.wrapperElement,
    revalidateWrapperRect = _b.revalidateWrapperRect,
    setIsFullscreen = _b.setIsFullscreen,
    setIsFullscreenSupported = _b.setIsFullscreenSupported;
  var _c = (0, _useFullscreen.default)(wrapperElement),
    open = _c.open,
    close = _c.close,
    isFullscreen = _c.isFullscreen,
    isSupported = _c.isSupported;
  (0, _react.useEffect)(function () {
    setIsFullscreen(isFullscreen);
  }, [setIsFullscreen, isFullscreen]);
  (0, _react.useEffect)(function () {
    setIsFullscreenSupported(isSupported);
  }, [setIsFullscreenSupported, isSupported]);
  var handleToggleFullscreen = (0, _react.useCallback)(function () {
    revalidateWrapperRect();
    if (isFullscreen) {
      close();
    } else {
      open();
    }
  }, [close, isFullscreen, open, revalidateWrapperRect]);
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsx)(Styled.FullscreenIcon, {
      className: className,
      variant: variant,
      "$isFullscreen": isFullscreen,
      onClick: handleToggleFullscreen
    })
  });
};
var _default = Fullscreen;
exports.default = _default;